<template>
  <div class="order-list" v-loading="loading">
    <div class="select-option">
      <el-row>
        <el-col :span="22">
          <div class="grid-content">
            <span style="color:red ">{{ $t('homePage.recommendation') }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col :span="24">
        <productList />
      </el-col>
      <!--创建报价单按钮-->
      <el-col el-col :span="2">
        <router-link to="/CreatOrderFirst">
          <el-button type="primary" size="small">
            {{ $t('homePage.createQuotation') }}
          </el-button>
        </router-link>
      </el-col>
    </el-row>
    <hr style="background-color: #c9caca; height: 1px; border: none">
    <div class="clear" />
    <el-row :gutter="5">
      <el-col :span="3">
        <div class="tree_list_class">
          <div class="order-list-files">
            <span>{{ $t('homePage.managementQuotation') }}</span>
          </div>
          <div class="order-list-files-button">
            <el-button
              style="padding: 3px;margin-left: 10px; color: #36BADE; border: 1px solid #36BADE;"
              icon="el-icon-plus"
              size="mini"
              @click="append(null,selectedfolder)"
            />
            <el-button
              style="padding: 3px; color: #36BADE; border: 1px solid #36BADE;"
              icon="el-icon-minus"
              size="mini"
              @click="remove(null,selectedfolder)"
            />
          </div>
          <el-tree
            :data="folderTree"
            default-expand-all
            :expand-on-click-node="false"
            :props="defaultProps"
            @node-click="initProjectList"
            @node-contextmenu="rightClick"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span><i class="productWeb iconwenjianjia" />{{ node.label }}</span>
            </span>
          </el-tree>

          <div
            v-show="menuVisible"
            id="menu" ref="menu"
            style="position:fixed;z-index: 2000;width: 200px"
          >
            <ul class="el-dropdown-menu el-popper">
              <li tabindex="-1" class="el-dropdown-menu__item" @click="() => append(null,selectedfolder)" v-show="treeButtonAdd">{{ $t('homePage.createFolder') }}</li>
              <li tabindex="-1" class="el-dropdown-menu__item" @click="() => edit(null,selectedfolder)" v-show="treeButtonEdit">{{ $t('homePage.modifyFolderSonName') }}</li>
              <li tabindex="-1" class="el-dropdown-menu__item" @click="() => remove(null,selectedfolder)" v-show="treeButtonDelete">{{ $t('homePage.deleteFolder') }}</li>
            </ul>
          </div>

          <div v-show="menuVisible1" id="menu1" ref="menu1" style="position:fixed;z-index: 2000;width: 200px">
            <ul class="el-dropdown-menu el-popper">
              <li tabindex="-1" class="el-dropdown-menu__item" @click="() => removeAll()">{{ $t('homePage.emptyRecycle') }}</li>
            </ul>
          </div>

          <div>
            <div class="grid-content ">
              <a
                href="javascript:void(0);"
                @click="setProjectType('1')"
                :class="flag===1?'active':''"
              >
                <span>
                  {{ $t('homePage.myCreated') }}
                  （ <span class="f-c-b">
                    {{ this.calNumber.myCreatedCount }}
                  </span> )
                </span>
              </a>
            </div>
            <div class="grid-content ">
              <a
                href="javascript:void(0);"
                @click="setProjectType('3')"
                :class="flag===3?'active':''"
              >
                <span>
                  {{ $t('homePage.myShareThe') }}
                  （ <span class="f-c-b">
                    {{ this.calNumber.myShareCount }}
                  </span> )
                </span>
              </a>
            </div>
            <div class="grid-content ">
              <a
                href="javascript:void(0);"
                @click="setProjectType('2')"
                :class="flag===2?'active':''"
              >
                <span>
                  {{ $t('homePage.shareWithMe') }}
                  （ <span class="f-c-b">
                    {{ this.calNumber.shareToMeCount }}</span> )
                </span>
              </a>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="21">
        <div class="table">
          <el-table
            :data="tableData3"
            border
            style="width: 100%"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          >
            <!--报价单名称-->
            <el-table-column
              prop="projectName"
              :label="$t('homePage.theNameList')"
              align="left"
              min-width="200"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="viewProject(scope.row.projectId,scope.row.projectName,scope.row.fileArchive)" style="user-select: unset"
                >
                  {{ scope.row.projectName }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="projectTotalPrice"
              :label="$t('homePage.directoryTotalPrice')"
              align="right"
              min-width="110"
              :formatter="productPriceFormat"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              prop="lastModifyDateTime"
              :label="$t('homePage.lastModified')"
              align="left"
              min-width="130"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              :label="$t('homePage.source')"
              align="left"
              min-width="120"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.projectType==='1'">
                  <!--我创建的-->
                  {{ $t('homePage.myCreated') }}
                </span>
                <span v-else-if="scope.row.projectType==='2'">
                  {{ scope.row.shareUserName }} {{ $t('homePage.shareWithMe') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('homePage.shareRecord')"
              align="left"
              min-width="100"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="bottom" @show="getShareList(scope.row.projectId)" @hide="shareList=[]">
                  <table class="view-table">
                    <tr>
                      <th>{{ $t('homePage.sharedObject') }}</th>
                      <th>{{ $t('homePage.sharingTime') }}</th>
                    </tr>
                    <tr v-for="(item,j) in shareList" :key="j">
                      <td>
                        {{ item.shareToName }}
                      </td>
                      <td>{{ item.shareDateTime }}</td>
                    </tr>
                  </table>
                  <span
                    slot="reference"
                    v-show="scope.row.isShare===1"
                    style="color: #36BADE;
                    cursor:pointer"
                  >
                    {{ $t('homePage.checkTime') }}
                  </span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('homePage.remarks')"
              align="left"
              min-width="100"
              :show-overflow-tooltip="false"
            >
              <template slot-scope="scope">
                <long-text :text="scope.row.projectRemark" :switch-flg="switchFlgP" />
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('homePage.operate')"
              align="left"
              min-width="300"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.fileArchive !== 0">
                  <span v-if="selectedfolder.folderType !== 1">
                    <el-button @click="editProject(scope.row.projectId,scope.row.projectName)" type="text">
                      {{ $t('homePage.modify') }}
                    </el-button>
                    <el-button @click="copyProject(scope.row.projectId)" type="text">
                      {{ $t('homePage.copy') }}</el-button>
                    <el-button @click="exportProject(scope.row.projectId)" type="text">
                      {{ $t('homePage.export') }}</el-button>
                    <el-button @click="shareProject(scope.row.projectId,scope.row.projectName)" type="text">
                      {{ $t('homePage.share') }}
                    </el-button>
                    <el-button @click="deleteProject(scope.row.projectId)" type="text">
                      <!--删除-->
                      {{ $t('homePage.delete') }}
                    </el-button>
                    <el-button
                      type="text"
                      @click="newRefreshPrice(scope.row.projectId)"
                      style="color: red"
                      v-if="scope.row.showComparison === 1"
                    >
                      <!--刷新价格-->
                      {{ $t('homePage.theRefreshPrice') }}
                    </el-button>
                  </span>
                  <el-button @click="openUserFold(scope.row.projectId)" type="text">
                    <!--移动到-->
                    {{ $t('homePage.moveTheTo') }}
                  </el-button>
                </span>
                <span v-if="scope.row.fileArchive === 0">
                  <el-button @click="archive(scope.row.projectId)" type="text">
                    <!--激活-->
                    {{ $t('homePage.activate') }}
                  </el-button>
                </span>
              </template>
            </el-table-column>
            <!--出口合规审查状态（最后一列）-->
            <el-table-column
              :label="$t('homePage.complianceStatus')"
              align="left"
              min-width="130"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.complianceTag"
                  :type="scope.row.complianceTag.type"
                  size="mini"
                >
                  {{ scope.row.complianceTag.text }}
                </el-tag>
                <i
                  v-if="scope.row.complianceStatus === 'PENDING'"
                  class="el-icon-refresh compliance-refresh-icon"
                  :class="{ 'is-loading': scope.row.complianceRefreshing }"
                  @click="refreshComplianceStatus(scope.row)"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 10px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.totalPage"
          />
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="shareTitle"
      :visible.sync="dialogFormVisible"
      width="450px"
    >
      <div style="text-align:left;">
        <p class="out-of-stock" v-if="shareMessageDto.lowerShelf !=null && shareMessageDto.lowerShelf !=''">
          {{ $t('homePage.productsPulledQuotation') }}{{ shareMessageDto.lowerShelf }}`
        </p>
        <p class="out-of-stock" v-if="shareMessageDto.spdcProduct !=null && shareMessageDto.spdcProduct !=''">
          <!--您的报价单中有服务商专供产品-->
          {{ $t('homePage.serviceProvidersQuotation') }}{{ shareMessageDto.spdcProduct }}
          <span v-if="shareMessageDto.orderInfo !=null && shareMessageDto.orderInfo !=''">
            {{ shareMessageDto.orderInfo }}
          </span>
        </p>
        <div style="padding-bottom: 10px">
          <span style="text-align: left;color:red;" v-if="shareMessageDto.supplyList !=null && shareMessageDto.supplyList.length>0">
            <!--您的报价单中有供应紧缺的产品-->
            {{ $t('homePage.shortagesProductsQuotation') }}
          </span>
          <span style="text-align: left;color:red;" v-if="shareMessageDto.deliveryPeriod !=null && shareMessageDto.deliveryPeriod !=''">
            <!--当前项目备货周期为  天，请提前在CRM系统上勾选备货。-->
            {{ $t('homePage.currentProjectCycle') }} {{ shareMessageDto.deliveryPeriod }} {{ $t('homePage.DaysCRMSystem') }}
          </span>
        </div>
        <div
          style="text-align: left;color:red"
          v-if="shareMessageDto.promptInformation ==null && shareMessageDto.promptInformation == ''"
        >
          {{ shareMessageDto.promptInformation }}
        </div>
        <div style="text-align: left;color:red" v-if="shareMessageDto.matchingFlg">
          <!--如若项目极简光交换机部署在弱电箱场景，必须采购后面详情指定弱电箱，请点击查看-->
          {{ $t('createQuotation.straussClickViewDetails') }}
          <el-button type="primary" @click="openWeakCurrentBoxScene"> {{ $t('homePage.details') }}</el-button>
        </div>
        <div class="myBlackColor" style="text-align: left;color:red; margin-bottom: 20px" v-if="shareMessageDto.supplyList != null && shareMessageDto.supplyList.length>0">
          <el-table
            :data="shareMessageDto.supplyList"
            border
            style="width: 100%;color: black"
          >
            <el-table-column
              prop="productName"
              :label="$t('homePage.productModel')"
              width="240"
            />
            <el-table-column
              prop="expectedMitigationDate"
              :label="$t('homePage.expectedEaseDate')"
              width="120"
            />
            <el-table-column
              prop="deliveryPeriod"
              :label="$t('homePage.stockCycle')"
              width="100"
            />
            <el-table-column
              prop="supplyRemarks"
              :label="$t('homePage.remarks')"
            />
          </el-table>
        </div>
        <div
          class="myBlackColor"
          style="text-align: left;color:red;margin-bottom: 20px"
          v-if="shareMessageDto.delistingProductList !=null && shareMessageDto.delistingProductList.length>0"
        >
          <div style="margin-bottom: 10px">
            <!--您的报价单中有退市的产品：-->
            {{ $t('createQuotation.quotationDeliStingProducts') }}
          </div>
          <el-table
            :data="shareMessageDto.delistingProductList"
            border
            style="width: 100%;color: black"
          >
            <el-table-column
              prop="productName"
              :label="$t('homePage.productModel')"
              width="240"
            />
            <el-table-column
              prop="statusDes"
              :label="$t('homePage.status')"
            />
          </el-table>
        </div>
      </div>
      <!--分享-->
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth">
          <el-row :gutter="20">
            <el-col :span="19">
              <div class="grid-content">
                <span v-if="form.crm_project_name!=''">
                  <!--项目名称:-->
                  {{ $t('homePage.projectName') }}
                </span>
                {{ form.crm_project_name }}
              </div>
              <div class="grid-content">
                <span v-if="form.crm_code!=''">
                  <!--业务机会编码:-->
                  {{ $t('homePage.businessCode') }}
                </span>
                {{ form.crm_code }}
              </div>
            </el-col>
            <el-col :span="19">
              <div class="grid-content">
                <span v-if="form.salesName!=''">
                  <!--外销:-->
                  {{ $t('homePage.exportSales') }}
                </span>
                {{ form.salesName }}
              </div>
              <div class="grid-content">
                <span v-if="form.preSalesName!=''">
                  <!--售前技术支持:-->
                  {{ $t('homePage.saleTechnicalSupport') }}
                </span>
                {{ form.preSalesName }}
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <span class="second-input">
          <el-form-item
            :label="$t('homePage.specifyPeopleShare')"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="userModel"
              filterable
              multiple
              remote
              :reserve-keyword="false"
              :placeholder="$t('homePage.pleaseEnterDesignatedShare')"
              :remote-method="remoteMethodUserBydebounce"
              :loading="loading"
              value-key="userId"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.userId"
                :label="item.userName"
                :value="item"
              >
                <span>
                  <span style="width: 140px;display: inline-block">
                    {{ `[${$t('homePage.name')}]：` + item.userName }}
                  </span>
                  <span>
                    [{{ $t('homePage.department') }}]：
                  </span>
                  <span v-if="item.deptName == null">
                    {{ $t('homePage.notHave') }}
                  </span>
                  <span v-if="item.deptName != null">
                    {{ item.deptName }}
                  </span>
                  <span v-if="item.partnerType != null">
                    {{ `[${$t('homePage.channelType')}]：` + item.partnerType }}
                  </span>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="shareObjecInfo">{{ $t('homePage.share') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('homePage.customizeWizard')"
      :visible.sync="dialogUserFolderVisible"
      :show-close="false"
      width="450px"
    >
      <el-form
        :model="userFolderFrom"
        :rules="rules"
        ref="userFolderFrom"
        :inline="true"
        @submit.native.prevent
        @keyup.enter.native="enterTrigerUserFold"
      >
        <el-form-item
          :label="$t('createQuotation.fileNameFolder')"
          :label-width="formLabelWidth"
          prop="folderName"
        >
          <el-input
            v-model.trim="userFolderFrom.folderName"
            :placeholder="$t('createQuotation.fileNameFolder')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUserFolderFrom">{{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="addUserFold" v-if="addFlg">{{ $t('homePage.newFolder') }}</el-button>
        <el-button type="primary" @click="editUserFold" v-if="editFlg">{{ $t('homePage.modifyFolderName') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('homePage.selectDiscountRefresh')"
      :visible.sync="RefreshPricedialogUserFolderVisible"
      width="450px"
      class="refresh-money-price"
    >
      <el-radio v-model="radio" label="1">
        {{ $t('createQuotation.discountSame') }}
      </el-radio>
      <el-radio v-model="radio" label="2">
        {{ $t('createQuotation.discountedUnchanged') }}
      </el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="RefreshPricedialogUserFolderVisible = false ">
          {{ $t('homePage.takeAway') }}
        </el-button>
        <el-button type="primary" @click="distinguishRefreshPrice">
          {{ $t('homePage.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!--移动到文件夹-->
    <el-dialog
      :title="$t('createQuotation.moveFolder')"
      :visible.sync="dialogMoveUserFolderVisible"
      @close="userFolderProjectFrom.folderName = ''"
      width="585px"
    >
      <el-popover
        placement="bottom"
        width="400"
        trigger="click"
        v-model="popoverFlg"
      >
        <div style="height: 350px;overflow-y: auto">
          <el-tree
            :data="folderTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
          />
        </div>
        <el-input
          slot="reference"
          v-model.trim="userFolderProjectFrom.folderName"
          :placeholder="$t('createQuotation.fileNameFolder')"
          readonly
          style="width: 50%"
        />
      </el-popover>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelMoveUserFolder">
          {{ $t('homePage.takeAway') }}
        </el-button>
        <el-button type="primary" @click="moveUserFolder">
          {{ $t('homePage.moveTo') }}
        </el-button>
      </div>
    </el-dialog>
    <WeakCurrentBoxScene ref="weakCurrentBoxScene" />
    <!--出口合规风险提示弹窗-->
    <ExportComplianceDialog
      :visible.sync="complianceDialog.visible"
      :mode="complianceDialog.mode"
      :level="complianceDialog.level"
      :conclusion="complianceDialog.conclusion"
      :details="complianceDialog.details"
      @cancel="onComplianceCancel"
      @confirm="onComplianceConfirm"
      @submit-review="onComplianceSubmitReview"
    />
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import api from '../../api';
import eventBus from '../../utils/eventBus';
import longText from './longText';
import productList from './ProductList';
import { productPriceFormat, ProductItem } from '../../utils/numberFormater';
import {isChannel, setStore} from '@/utils/mUtils';
import {  getStore } from '@/utils/mUtils';
import WeakCurrentBoxScene from '../components/WeakCurrentBoxScene';
import exportCompliance from '@/utils/exportCompliance';
export default {
  name: 'QuotationList',
  mixins: [ProductItem, exportCompliance],
  data () {
    return {
      formLabelWidth: '120px',
      options: [],
      dialogFormVisible: false,
      userModel: [],
      crmModel: '',
      userOptions: [],
      loading: false,
      form: {
        crm_code: '',
        crm_project_name: '',
        salesName: '',
        preSalesName: ''
      },
      tempProjectId: '',
      pagination: {
        currentPage: 1,
        totalPage: 0,
        pageSize: 15,
        pageSizes: []
      },
      tableData3: [],
      // 出口合规审查状态（projectId -> status）
      complianceStatusMap: {},
      queryParam: {
        projectType: '',
        isShare: -1,
        searchKeyWords: '',
        pageSize: '15',
        pageIndex: '1',
        projectId: '',
        folderId: '',
        flagCheck: false
      },
      flag: 0,
      calNumber: [],
      IsChannel: false,
      isShare: false,
      switchFlgP: true,
      shareTitle: '',
      folderTree: [],
      defaultProps: {
        children: 'children',
        label: 'folderName'
      },
      selectedfolder: {},
      userFolderFrom: {
        folderId: '',
        folderName: '',
        parentFolderId: '',
        folderLevel: 1,
        folderType: '',
        projectId: ''
      },
      userFolderProjectFrom: {
        folderId: '',
        projectId: '',
        folderName: '',
        folderType: ''
      },
      rules: {
        folderName: [{ required: true, message: '文件夹名称不可空', trigger: 'blur' }]
      },
      dialogUserFolderVisible: false,
      addFlg: false,
      editFlg: false,
      dialogMoveUserFolderVisible: false,
      menuVisible: false,
      menuVisible1: false,
      treeButtonAdd: false,
      treeButtonEdit: false,
      treeButtonDelete: false,
      folderHeight: 0,
      popoverFlg: false,
      shareList: [],
      radio: '1',
      RefreshPricedialogUserFolderVisible: false,
      refreshPriceProjectId: '',
      dialogTwoVisible: false

    };
  },
  components: { longText, productList, WeakCurrentBoxScene },
  methods: {
    productPriceFormat,
    shareObjecInfo () {
      let submitModel = [];
      let crmUser = [];
      submitModel = [...this.userModel, ...crmUser];
      if (submitModel.length > 0) {
        let body = {
          projectId: this.tempProjectId,
          commonUserDTOList: submitModel
        };
        // 分享前先做出口合规检测，通过后再提交分享（携带检测标识供服务端绑定校验）
        this.runExportCompliance(this.tempProjectId, (detectionId) => {
          body.detectionId = detectionId;
          this.loading = true;
          api.toShare(body).then((res) => {
            let json = res.data;
            this.showPrompt(json);
          }).catch(() => {
            this.loading = false;
          });
        });
      } else {
        this.$notify.error('请填写指定人！');
      }
    },
    showPrompt (json) {
      if (json.status === '200') {
        this.$notify.success('分享成功！');
      } else if (json.status === '203') {
        let failedUsers = '';
        let reson = '';
        json.data.forEach((userList, index) => {
          failedUsers += index === json.data.length - 1 ? userList.commonUserDTO.userName : userList.commonUserDTO.userName + ',';
          reson += userList.commonUserDTO.userName + `${this.$t('homePage.notAvailable')}`;
          let products = userList.productInfoLists;
          products.forEach((product, index) => {
            reson += index === userList.productInfoLists.length - 1 ? product.productName + `${this.$t('homePage.permissionsProducts')}` : product.productName + '、';
          });
        });
        reson += `${this.$t('homePage.pleaseModifyShare')}`;
        let warningContent = '分享【' + failedUsers + '】失败。原因：' + reson;
        this.$notify.error(warningContent);
      } else {
        this.$notify.error(json.data);
      }
      this.dialogFormVisible = false;
      this.resetShareForm();
      this.initProjectList();
      this.initProjectCount();
    },
    // 检索CRM项目名称
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        api.getCRMInfoByConditions({ params: { 'keys': query } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.options = json.data;
            if (json.data != null && this.isShare && json.data.length === 1) {
              if (json.data.length > 0) {
                // this.initShareCrmInfo(json.data[0]);
              } else {
                this.$notify.warning(`${this.$t('homePage.userNoCRMInformation')}`);
              }
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$notify.error(json.err);
          }
        }).catch(() => {
          // this.loading = false;
          // this.$notify.error("检索CRM信息异常！", e);
        });
      } else {
        this.options = [];
      }
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    remoteMethodUserBydebounce: XEUtils.debounce(
      function (query) {
        this.remoteMethodUser(query);
      },
      1300
    ),
    // 根据关键字检索用户 > 指定人分享
    remoteMethodUser (query) {
      if (query !== '') {
        this.loading = true;
        api.seachUserByKey({ params: { 'key': query } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.loading = false;
            this.userOptions = json.data;
          } else {
            this.$notify.error(json.data);
          }
        }).catch(() => {
          this.$notify.error('网络异常!');
        });
      } else {
        this.userOptions = [];
      }
    },
    deleteProject (projectId) {
      this.$confirm(`${this.$t('homePage.deleteProjectContinue')}`, `${this.$t('homePage.prompt')}`, {
        confirmButtonText: this.$t('homePage.deleteOk'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning',
        customClass: 'custom-message'
      }).then(() => {
        if (projectId != null) {
          this.loading = true;
          api.deleteProject({ params: { projectId: projectId } }).then((response) => {
            let jsonData = response.data;
            if (jsonData.status === '200') {
              this.$notify({
                type: 'success',
                message: this.$t('homePage.deletedSuccessFully')
              });
              this.resetCurrentParams();
              if (this.selectedfolder.folderId) {
                this.initProjectList(this.selectedfolder);
              } else {
                this.initProjectList();
              }
              this.initProjectCount();
            }
          }).catch(() => {
            this.loading = false;
            this.$notify.error(this.$t('homePage.deleteProjectFailure'));
          });
        }
      });
    },
    shareProject (projectId, projectName) {
      this.tempProjectId = projectId;
      this.dialogFormVisible = true;
      this.isShare = true;
      // this.shareTitle = '分享报价单－' + projectName;
      this.shareTitle = `${this.$t('createQuotation.shareQuotation')}－` + projectName;
      this.getLowershelf(projectId);
      if (!this.IsChannel) {
        this.resetShareForm();
        this.options = [];
        this.crmModel = '';
        // 加载一选中crm信息
      }
    },
    exportProject (projectId) {
      if (projectId != null) {
        this.$router.push({ name: 'exportOrder/export', params: { projectId: projectId } });
      }
    },
    copyProject (projectId) {
      if (projectId != null) {
        this.$confirm(this.$t('createQuotation.copyQuotationContinue'), this.$t('homePage.prompt'), {
          confirmButtonText: this.$t('homePage.confirm'),
          cancelButtonText: this.$t('homePage.takeAway'),
          type: 'warning',
          customClass: 'custom-message'
        }).then(() => {
          api.copyProject({ params: { projectId: projectId } }).then((response) => {
            let jsonData = response.data;
            if (jsonData.status === '200') {
              this.$notify({
                type: 'success',
                message: this.$t('createQuotation.copySuccess')
              });
              this.resetCurrentParams();
              if (this.selectedfolder.folderId) {
                this.initProjectList(this.selectedfolder);
              } else {
                this.initProjectList();
              }
              this.initProjectCount();
            }else {
              this.$notify.error(jsonData.err);
            }
          }).catch(() => {
            this.$notify.error(this.$t('createQuotation.copyProjectFailureError'));
          });
        });
      }
    },
    // 查看配置组详情
    viewProject (projectId, projectName, fileArchive) {
      if (projectId != null) {
        // 真实数据需要改name为配置组id，路由里面也需要改
        this.$router.push({ name: 'OrderDetail/detail', params: { projectId: projectId, projectName: projectName, fileArchive: fileArchive } });
      }
    },
    editProject (projectId, projectName) {
      if (projectId != null) {
        // 真实数据需要改name为配置组id，路由里面也需要改
        setStore('secondProjectName',projectName);
        this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: projectId, projectName: projectName } });
      }
    },
    // 改变每页显示的条数
    handleSizeChange (val) {
      this.queryParam.pageSize = val;
      this.initProjectList();
    },
    // 下一页
    handleCurrentChange (val) {
      this.queryParam.pageIndex = val;
      this.initProjectList();
    },
    // 我的项目列表
    initProjectList (data) {
      this.menuVisible = false;
      this.menuVisible1 = false;
      this.loading = true;
      if (data) {
        this.queryParam.folderId = data.folderId;
        this.queryParam.isShare = -1;
        this.queryParam.projectType = '';
        this.queryParam.pageIndex = 1;
        this.flag = 0;
        this.selectedfolder = data;
      }
      api.getProjectListByCurrentUser(this.queryParam).then((responseData) => {
        let jsonData = responseData.data;
        if (jsonData.status === '200') {
          if (jsonData.data.total > 0) {
            this.pagination.totalPage = jsonData.data.total;
            this.pagination.pageSizes = [this.pagination.pageSize, this.pagination.pageSize + 5];
            jsonData.data.list.forEach((item) => {
              item.ifShow = false;
            });
            this.tableData3 = jsonData.data.list;
            this.loadComplianceStatus(jsonData.data.list);
            this.loading = false;
          } else {
            this.pagination.totalPage = 0;
            this.pagination.pageSizes = [this.pagination.pageSize, this.pagination.pageSize + 5];
            this.tableData3 = [];
            this.complianceStatusMap = {};
            this.loading = false;
          }
          this.loading = false;
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },
    // 加载当前页报价单的出口合规审查状态
    loadComplianceStatus (list) {
      if (!list || !list.length) {
        this.complianceStatusMap = {};
        return;
      }
      let projectIds = [];
      list.forEach((item) => {
        if (item.projectId && projectIds.indexOf(item.projectId) === -1) {
          projectIds.push(item.projectId);
        }
      });
      if (!projectIds.length) {
        this.complianceStatusMap = {};
        return;
      }
      api.exportComplianceStatusBatch({ projectIds: projectIds }).then((responseData) => {
        let jsonData = responseData.data;
        let map = {};
        if (jsonData.status === '200' && jsonData.data) {
          jsonData.data.forEach((item) => {
            map[item.projectId] = item;
          });
        }
        this.complianceStatusMap = map;
        this.applyComplianceTags(list);
      }).catch(() => {
        this.complianceStatusMap = {};
        this.applyComplianceTags(list);
      });
    },
    // 将合规状态标签预处理到列表行，避免模板中重复调用方法
    applyComplianceTags (list) {
      (list || []).forEach((row) => {
        let status = this.complianceStatusMap[row.projectId];
        this.$set(row, 'complianceStatus', status ? status.handleStatus : null);
        this.$set(row, 'complianceTag', this.complianceStatusTag(row));
      });
    },
    // 手动刷新审查状态（回调未送达时的兜底）
    refreshComplianceStatus (row) {
      if (row.complianceRefreshing) {
        return;
      }
      this.$set(row, 'complianceRefreshing', true);
      api.exportComplianceReviewRefresh({ projectId: row.projectId }).then((res) => {
        this.$set(row, 'complianceRefreshing', false);
        let json = res.data;
        if (json.status === '200' && json.data) {
          this.$set(this.complianceStatusMap, row.projectId, json.data);
          this.$set(row, 'complianceStatus', json.data.handleStatus);
          this.$set(row, 'complianceTag', this.complianceStatusTag(row));
          this.$message.success(this.$t('exportCompliance.refreshSuccess'));
        } else {
          this.$message.error(this.$t('exportCompliance.refreshFailed'));
        }
      }).catch(() => {
        this.$set(row, 'complianceRefreshing', false);
        this.$message.error(this.$t('exportCompliance.refreshFailed'));
      });
    },
    // 合规状态标签（待审批/已通过/未通过）
    complianceStatusTag (row) {
      let status = this.complianceStatusMap[row.projectId];
      if (!status || !status.handleStatus) {
        return null;
      }
      if (status.handleStatus === 'PENDING') {
        return { type: 'warning', text: this.$t('exportCompliance.statusPending') };
      }
      if (status.handleStatus === 'HANDLED') {
        if (status.handleResult === 1) {
          return { type: 'success', text: this.$t('exportCompliance.statusPassed') };
        }
        if (status.handleResult === 2) {
          return { type: 'danger', text: this.$t('exportCompliance.statusRejected') };
        }
      }
      return null;
    },
    // 我的项目总价
    initProjectCount () {
      api.getCalCount().then((responseData) => {
        let jsonData = responseData.data;
        if (jsonData.status === '200') {
          this.calNumber = jsonData.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    setProjectType (val) {
      this.flag = val;
      if (val === '1') {
        // 我创建的
        this.queryParam.projectType = '1';
        this.queryParam.isShare = -1;
      } else if (val === '2') {
        // 分享给我的
        this.queryParam.projectType = '2';
        this.queryParam.isShare = -1;
      } else if (val === '3') {
        // 我分享的
        this.queryParam.projectType = '';
        this.queryParam.isShare = 1;
      } else {
        this.queryParam.projectType = '';
        this.queryParam.isShare = -1;
      }
      this.queryParam.searchKeyWords = '';
      this.resetCurrentParams();
      this.selectedfolder = {};
      this.initProjectList();
    },
    changText (row) {
      if (row.ifShow === undefined) {
        this.$set(row, 'ifShow', true);
      } else {
        row.ifShow = !row.ifShow;
      }
    },
    remarkText (val) {
      let cont = '';
      cont = val.length > 28 ? val.substring(0, 28) : val;
      return cont;
    },
    resetCurrentParams () {
      this.pagination.currentPage = 1;
      this.queryParam.pageIndex = '1';
      this.queryParam.folderId = '';
      // this.selectedfolder = {};
    },
    // 选择CRM时 自动带出客户名称
    selectCRM () {
      this.form.crm_code = this.crmModel.crm_code;
      this.form.crm_project_name = this.crmModel.crm_project_name;
      this.form.salesName = this.crmModel.salesName;
      this.form.preSalesName = this.crmModel.preSalesName;
    },
    // 获取当前用户信息
    getUserInfo () {
      let temp = getStore(`partnerFlg`);
      if (temp && temp !== null && temp !== '') {
        this.IsChannel = isChannel(temp);
      } else {
        api.getUserInfo().then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data !== null) {
            if (isChannel(json.data.partnerFlg)) {
              this.IsChannel = true;
            } else {
              this.IsChannel = false;
            }
          } else {
            this.$notify.error(json.err);
          }
        }).catch((e) => {
          console.log(e);
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
      }
    },
    initShareCrmInfo (crm) {
      if (this.isShare && !this.IsChannel) {
        this.selectCRM(crm);
      }
    },
    resetShareForm () {
      this.form.crm_code = '';
      this.form.crm_project_name = '';
      this.form.salesName = '';
      this.form.preSalesName = '';
    },
    // 激活
    archive (projectId) {
      this.$confirm(this.$t('homePage.hasBeenActivated'), this.$t('homePage.prompt'), { confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning' }).then(() => {
        api.archive(projectId).then((responseData) => {
          let json = responseData.data;
          if (json.status === '200') {
            // 添加成功
            this.$notify.success(this.$t('homePage.activateSuccess'));
          } else {
            this.$notify.error(this.$t('homePage.activateError'));
          }
          this.initProjectList();
        });
      });
      // api.archive(projectId)
    },

    // 刷新价格
    refreshPrice (projectId) {
      this.$confirm('是否刷新价格？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.queryParam.projectId = projectId;
        api.refreshPrice(this.queryParam).then((responseData) => {
          let jsonData = responseData.data;
          if (jsonData.status === '200') {
            this.loading = false;
            this.$alert(jsonData.data, { dangerouslyUseHTMLString: true });
            this.queryParam.projectId = '';
            this.initProjectList();
          }
        }).catch((err) => {
          this.queryParam.projectId = '';
          this.loading = false;
          console.log(err);
          this.$notify({
            type: 'success',
            message: '修改失败!'
          });
        });
      });
    },
    newRefreshPrice (projectId) {
      this.refreshPriceProjectId = projectId;
      this.RefreshPricedialogUserFolderVisible = true;
    },
    distinguishRefreshPrice () {
      this.RefreshPricedialogUserFolderVisible = false;
      this.loading = true;
      let param = {
        params: {
          projectId: this.refreshPriceProjectId,
          radio: this.radio
        }
      };
      api.distinguishRefreshPrice(param).then((responseData) => {
        let jsonData = responseData.data;
        if (jsonData.status === '200') {
          this.$alert(jsonData.data, {
            customClass: 'msgBox',
            dangerouslyUseHTMLString: true
          });
          // this.$alert(jsonData.data,{dangerouslyUseHTMLString:true});
          this.refreshPriceProjectId = '';
          this.radio = '1';
          this.loading = false;
          this.initProjectList();
        }
      }).catch((err) => {
        this.refreshPriceProjectId = '';
        this.radio = '1';
        this.loading = false;
        console.log(err);
        this.$notify({
          type: 'success',
          message: '刷新失败!'
        });
      });
    },
    append (node, data) {
      if (!data.folderId) {
        this.$notify.error(this.$t('homePage.pleaseSelectFolder'));
        return false;
      } else {
        this.userFolderFrom.parentFolderId = data.folderId;
        this.userFolderFrom.folderLevel = data.folderLevel + 1;
        this.userFolderFrom.folderType = data.folderType;
      }
      if (data.folderLevel === 3) {
        this.$notify.error(this.$t('homePage.newFolderLevel'));
        return false;
      }
      if (data.folderType !== 2) {
        this.$notify.error(this.$t('homePage.onlyCreateFolder'));
        return false;
      }
      this.addFlg = true;
      this.editFlg = false;
      this.dialogUserFolderVisible = true;
    },
    edit (node, data) {
      this.userFolderFrom.parentFolderId = data.parentFolderId;
      this.userFolderFrom.folderId = data.folderId;
      this.userFolderFrom.folderType = data.folderType;
      this.userFolderFrom.folderName = data.folderName;
      this.addFlg = false;
      this.editFlg = true;
      this.dialogUserFolderVisible = true;
    },
    remove (node, data) {
      if (!data.folderId) {
        this.$notify.error(this.$t('homePage.pleaseSelectFolder'));
        return false;
      }
      if (data.folderType !== 2) {
        this.$notify.error(this.$t('homePage.onlyDeleteFolder'));
        return false;
      }

      this.userFolderFrom.folderId = data.folderId;
      this.$confirm(this.$t('homePage.deleteFoldersConfirm'), this.$t('homePage.prompt'), {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        api.removeUserFold({ params: { folderId: data.folderId, folderLevel: data.folderLevel } }).then((response) => {
          let jsonData = response.data;
          if (jsonData.status === '200') {
            this.$notify({
              type: 'success',
              message: this.$t('homePage.deletedSuccessFully')
            });
            this.getUserFolderTree();
            this.initProjectList();
            this.initProjectCount();
          }
        }, (err) => {
          this.$notify.error(this.$t('homePage.deleteFailureAdministrator'));
        });
      });
    },

    removeAll () {
      this.$confirm(this.$t('homePage.confirmRecycleBin'), this.$t('homePage.prompt'), {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        api.removeAll().then((responseData) => {
          let json = responseData.data;
          if (json.status === '200') {
            // 添加成功
            this.$notify.success(this.$t('homePage.emptyRecycleSuccess'));
          } else {
            this.$notify.error(this.$t('homePage.emptyRecycleFailure'));
          }
          this.initProjectList();
        });
        this.menuVisible1 = false;
      });
    },

    getUserFolderTree () {
      api.getUserFolderTree({ params: { 'folderId': '1' } }).then((res) => {
        let json = res.data;
        if (json.status === '200' && json.data != null) {
          this.folderTree = json.data;
        } else {
          this.$notify.error(this.$t('homePage.errorGettingUser'));
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error(this.$t('homePage.networkAnomaly'));
      });
    },

    enterTrigerUserFold () {
      if (this.addFlg) {
        this.addUserFold();
      }
      if (this.editFlg) {
        this.editUserFold();
      }
    },
    addUserFold () {
      this.$refs['userFolderFrom'].validate(valid => {
        if (valid) {
          api.addUserFold(this.userFolderFrom).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$notify.success(this.$t('homePage.newFolderSuccess'));
              this.getUserFolderTree();
              this.cancelUserFolderFrom();
            } else {
              this.$notify.error(this.$t('homePage.newFolderRepeated'));
            }
          }).catch((e) => {
            console.log(e);
            this.$notify.error(this.$t('homePage.newFolderRepeated'));
          });
        }
      });
    },
    editUserFold () {
      this.$refs['userFolderFrom'].validate(valid => {
        if (valid) {
          api.editUserFold(this.userFolderFrom).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$notify.success(this.$t('homePage.modifyTheFolderName'));
              this.getUserFolderTree();
              this.cancelUserFolderFrom();
            } else {
              this.$notify.error(this.$t('homePage.newFolderRepeated'));
            }
          }).catch((e) => {
            console.log(e);
            this.$notify.error(this.$t('homePage.newFolderRepeated'));
          });
        }
      });
    },
    openUserFold (projectId) {
      this.userFolderProjectFrom.projectId = projectId;
      this.dialogMoveUserFolderVisible = true;
    },
    handleNodeClick (data) {
      this.popoverFlg = false;
      this.userFolderProjectFrom.folderName = data.folderName;
      this.userFolderProjectFrom.folderId = data.folderId;
      this.userFolderProjectFrom.folderType = this.selectedfolder.folderType;
    },
    moveUserFolder () {
      if (this.userFolderProjectFrom.folderName.trim() === '' || !this.userFolderProjectFrom.folderId || this.userFolderProjectFrom.folderId === '') {
        this.$notify.error(this.$t('homePage.pleaseSelectFolder'));
        return false;
      }
      api.moveUserFolder(this.userFolderProjectFrom).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(this.$t('homePage.moveQuotationSuccess'));
          // 调用我的报价总接口
          this.initProjectCount();
          this.initProjectList();
          this.dialogMoveUserFolderVisible = false;
        } else {
          this.$notify.error(this.$t('homePage.mobileQuotationFailure'));
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error(this.$t('homePage.mobileQuotationFailure'));
      });
      this.userFolderProjectFrom.folderName = '';
    },
    rightClick (event, object) {
      this.flag = 0;
      this.selectedfolder = object;
      this.treeButtonAddFlg();
      this.treeButtonEditFlg();
      this.treeButtonDeleteFlg();
      if (object.folderType === 2 && object.folderLevel < 4) {
        this.menuVisible = true;
        let menu = document.querySelector('#menu');
        /* 菜单定位基于鼠标点击位置 */
        menu.style.left = event.clientX + 20 + 'px';
        menu.style.top = event.clientY + 10 + 'px';
      } else {
        this.menuVisible = false;
      }
      if (object.folderType === 1 && object.folderLevel < 3) {
        this.menuVisible1 = true;
        let menu = document.querySelector('#menu1');
        menu.style.left = event.clientX + 20 + 'px';
        menu.style.top = event.clientY + 10 + 'px';
      } else {
        this.menuVisible1 = false;
      }
    },

    treeButtonAddFlg () {
      if (this.selectedfolder.folderType === 2 && this.selectedfolder.folderLevel < 3) {
        this.treeButtonAdd = true;
      } else {
        this.treeButtonAdd = false;
      }
    },
    treeButtonEditFlg () {
      if (this.selectedfolder.folderType === 2 && this.selectedfolder.folderLevel > 1) {
        this.treeButtonEdit = true;
      } else {
        this.treeButtonEdit = false;
      }
    },
    treeButtonDeleteFlg () {
      if (this.selectedfolder.folderType === 2 && this.selectedfolder.folderLevel > 1) {
        this.treeButtonDelete = true;
      } else {
        this.treeButtonDelete = false;
      }
    },
    showMenu (e) {
      if (!this.$refs.menu.contains(e.target)) {
        this.menuVisible = false;
      }
      if (!this.$refs.menu1.contains(e.target)) {
        this.menuVisible1 = false;
      }
    },

    cancelMoveUserFolder () {
      this.userFolderProjectFrom = {
        folderId: '',
        projectId: '',
        folderName: '',
        folderType: ''
      };
      this.dialogMoveUserFolderVisible = false;
    },

    cancelUserFolderFrom () {
      this.$refs['userFolderFrom'].resetFields();
      this.dialogUserFolderVisible = false;
    },
    getShareList (projectId) {
      api.getShareList({ params: { projectId: projectId } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.shareList = json.data;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    openWeakCurrentBoxScene () {
      this.$refs.weakCurrentBoxScene.openWeakCurrentBoxScene();
    }
  },
  mounted () {
    this.getUserInfo();
    this.getUserFolderTree();
    this.initProjectList();
    this.initProjectCount();
  },
  created () {
    eventBus.$on('searchByKeyWords', (args, flag) => {
      this.queryParam.searchKeyWords = args;
      this.queryParam.projectType = '';
      this.queryParam.isShare = -1;
      this.queryParam.pageIndex = 1;
      this.flag = 0;// 初始化统计状态
      this.queryParam.flagCheck = flag;
      // this.resetCurrentParams();
      this.initProjectList();
    });
    document.addEventListener('click', this.showMenu, false);
  },
  destroyed () {
    eventBus.$off('searchByKeyWords');
    document.removeEventListener('click', this.showMenu);
  }
};
</script>

<style lang="scss">
  .order-list{
    .refresh-money-price{
      .el-dialog__header span{ // 弹出框标题大小
        word-break: break-word;
        font-size: 17px !important;
      }
    }
    .el-dialog__header span{ // 弹出框标题大小
      word-break: break-word;
      font-size: 18px !important;
    }
    .el-dialog__footer{ // 弹出框按钮居右
      text-align: right;
    }
    .el-dialog__body{
      text-align: left;
    }
  }
  .custom-message { // 确认弹框上下居中
    vertical-align: baseline;
    .el-message-box__status{ // icon大小
      font-size: 20px !important;
    }
  }
</style>

<style scoped lang="scss">
  .view-table{
    tr th{
      width: 200px;
    }
    tr td {
      font-size: 12px;
    }
  }
  .msgBox{
    max-height: 500px;
    overflow-y: auto;
  }
  .order-list {
    width: 100%;
    .el-pagination{
      padding: 2px 0px !important;
    }
  }
  .order-list .active {
    color: #36BADE;
    font-weight: 700;
    min-width: 102px;
    display: inline-block;
  }

  .order-list .table {
    margin-top: 1rem;
  }

  .order-list .el-tag {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    background: none;
    border: none;
    font-size: 1.4rem;
    color: #606266;
    margin: 0;
  }

    ::v-deep .el-dialog__header {
      text-align: left;
      font-size: 1.6rem;
      border-bottom: 1px solid #EBEBEB;
      padding: 16px 20px 10px;
    }

  .el-tag:hover {
    background: none;
  }

  .name-wrapper .el-tag:hover {
    background: none;
  }

  .cell:hover .el-tag {
    background: none;
  }

  .el-menu-demo:hover .el-tag {
    background: none;
  }

  .el-menu1-demo:hover .el-tag {
    background: none;
  }

  .el-table__row:hover .el-tag {
    background: none;

  }

  table th .cell {
    color: #333333;
  }

  .order-list table tr td:nth-of-type(1) {
    color: #36BADE;
  }
  .myBlackColor table tr td:nth-of-type(1) {
    color: black;
  }

  .order-list table tr td:nth-of-type(6) {
    color: #36BADE;
  }

  .tree_list_class {
    margin-top: 1rem;
    min-height: 550px;
    max-height: 100%;
    border-right: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 20px;
    overflow-y:auto;
    .order-list-files{
      background: #F0F8FF;
      height: 4rem;
      line-height: 4rem;
      padding-top: 1px;
  }
    .order-list-files-button{
      text-align: right;
      margin:10px 5px;
    }
  }

  .tree_list_class .grid-content {
    text-align: left;
    padding-left: 22px;
    margin-top: 20px;
    color: black;
  }

  .el-pager li .active {
    color: #36BADE;
  }

  .order-list .el-dialog .grid-content {
    line-height: 3.2rem;
    float: left;
    width: 50%;
    text-align: left;
  }

  .order-list .blue-btn {
    text-align: right;
  }

  .order-list .blue-btn {
    background: #36BADE;
    width: 12rem;
    height: 3.2rem;
    color: #FFFFFF;
    border-radius: 5px;
    line-height: 3.2rem;
    text-align: center;
    position: absolute;
    right: 0;
    cursor: pointer;
  }

  .order-list .blue-btn:hover {
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }

  .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }

  .clear {
    clear: both;
  }

  .order-list .select-option .grid-content {
    float: left;
    margin-left: 2rem;
    min-width: 102px;
    padding: 1px;
  }

  .order-list .select-option .grid-content:first-of-type {
    margin-left: 0;
  }

  .el-table td, .el-table th {
    height: 2rem;
  }

  .order-list .grid-content .f-c-b {
    color: #000000;
  }

  // .order-list .table table .cell {
  //   white-space: normal;
  // }

  .order-list .table table .el-table__row .el-button--text {
    text-align: left;
    white-space: normal;
    line-height: 2rem;
    height: 100%;
    margin-right: 17px;
  }

  .order-list .table tbody tr td:nth-of-type(5) {
    text-align: justify;
  }

  .order-list .select-option .el-button--primary {
    float: right;
  }

  .order-list .el-dialog .el-dialog__footer {
    text-align: center;
  }

  .order-list .el-dialog .el-select {
    width: 100%;
  }

  .order-list .second-input .el-select__input:focus {
    border: none !important;
  }

  .order-list .second-input .el-select__input:hover {
    border: none !important;
  }

  .order-list .refresh-money{
    width: 24px;
  }

  // 合规状态手动刷新图标
  .compliance-refresh-icon {
    margin-left: 6px;
    color: #909399;
    cursor: pointer;

    &:hover {
      color: #009688;
    }

    &.is-loading {
      animation: rotating 1.5s linear infinite;
      pointer-events: none;
    }
  }

  .order-list table tr,
  .order-list table tr th,
  .order-list table tr td,
  .order-list table tr td .el-button--text
  {
    height: 3.6rem;
    padding: 0;
    margin: 0;
  }
  .el-dialog__body {
    padding: 30px 30px;
    color: #606266;
    font-size: 14px;
  }

  .out-of-stock{
    padding: 10px 10px;
    color: #dd0000;
    font-size: 14px;
    border: 1px solid red;
    text-align: left;
    margin-bottom: 20px;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background-color: #ccc !important;
  }
  .order-list{
    ::v-deep .el-tree-node{
      margin-top: 20px;
      color: black;
    }
  }
  .el-button{
    //height: 2rem;
    //line-height: 0rem;
  }
  .el-input__inner{
    height: 2.2rem;
    line-height: 2.2rem;
  }

  .order-list .select-option {
    padding-top: 1rem;
    margin-bottom: 2rem;
  }

  @media screen and (max-width: 1440px) {
    .order-list .el-button+.el-button {
      margin-left:4px!important;
    }
  }

  @media screen and (max-width: 1366px) {
    .order-list {
      width: 100%;
    }

    .order-list .select-option {
      padding-top: 1rem;
    }

    .add-product .product-input .el-input--suffix {
      width: 80%;
    }

    .order-list .select-option .el-row .grid-content {
      height: 2rem;
      line-height: 2rem;
      font-size: 1.4rem;
      min-width: 10rem;
    }

    .order-list .table {
      margin-top: 1rem;
    }

    .order-list table tr,
    .order-list table tr th,
    .order-list table tr td,
    .order-list table tr td .el-button--text {
      height: 2.8rem;
      font-size: 1.2rem;
      padding: 0;
      margin: 0;
    }

    .order-list .cell span {
      font-size: 1.2rem;
    }

    .order-list .block {
      margin-top: 1.5rem;
    }
  }

  @media screen and (max-width: 1280px) {

    .order-list .select-option .el-row .grid-content {
      height: 2rem;
      line-height: 2rem;
      font-size: 1.4rem;
    }

    .order-list .blue-btn {
      width: 10rem;
      height: 2.8rem;
      line-height: 2.8rem;
      font-size: 1.2rem !important;
    }

    .order-list .table {
      margin-top: 1rem;
    }

    .order-list table tr,
    .order-list table tr th,
    .order-list table tr td {
      height: 3rem;
      font-size: 1.2rem;
    }

    .order-list .cell span {
      font-size: 1.2rem;
    }
  }
  @keyframes move {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }

  .noticeBarText {
    animation: move 30s linear infinite;
    padding: 0;
    margin: 0;
    color:#FFFFFF;
  }

  .noticeBar:hover {
    animation-play-state: paused;
  }

  .noticeBar {
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    background: deepskyblue;
    width: 100%;
    overflow: hidden;
    text-align: initial;
  }
</style>
